// extracted by mini-css-extract-plugin
module.exports = {"logo":"xymD5tW6","logoMini":"BrCpkHW7","root":"EF5zoB4V"};